/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: '/',
    name: 'Dashboard',
    slug: 'home',
    icon: 'HomeIcon'
  },
  // {
  //   url: '',
  //   name: 'Inventory',
  //   slug: 'home',
  //   icon: 'EyeIcon'
  // },
  // {
  //   url: '',
  //   name: 'Formulations & NPD',
  //   slug: 'home',
  //   icon: 'HomeIcon'
  // },
  // {
  //   url: '',
  //   name: 'Sales & Marketing',
  //   slug: 'home',
  //   icon: 'HomeIcon'
  // },
  // {
  //   header: 'Orders',
  //   icon: 'ArchiveIcon',
  //   items: [
  //     {
  //       name: 'Inventory',
  //       slug: 'home',
  //       icon: 'ListIcon'
  //     },
  //     {
  //       name: 'Formulations & NPD',
  //       slug: 'home',
  //       icon: 'ShareIcon'
  //     },
  //     {
  //       name: 'Quality Assurance',
  //       slug: 'home',
  //       icon: 'SquareIcon'
  //     }
  //   ]
  // },
  // {
  //   header: 'Sales & Marketing',
  //   icon: 'ArchiveIcon',
  //   items: [
  //     {
  //       name: 'Reporting',
  //       slug: 'home',
  //       icon: 'PaperclipIcon'
  //     },
  //     {
  //       name: 'Budgeting',
  //       slug: 'home',
  //       icon: 'BriefcaseIcon'
  //     },
  //     {
  //       name: 'HR & People',
  //       slug: 'home',
  //       icon: 'UserXIcon',
  //       submenu: [
  //         {
  //           name: 'Recruitment',
  //           slug: 'page2',
  //           icon: 'UsersIcon'
  //         },
  //         {
  //           url: '/pages/hr-people',
  //           name: 'Staff Records',
  //           slug: 'page2',
  //           icon: 'UsersIcon'
  //         },
  //         {
  //           name: 'Staff Reports',
  //           slug: 'page2',
  //           icon: 'UsersIcon'
  //         },
  //         {
  //           name: 'Staff Performance',
  //           slug: 'page2',
  //           icon: 'UsersIcon'
  //         }
  //       ]
  //     }
  //   ]
  // },
  {
    header: 'Supplier Details',
    icon: 'ArchiveIcon',
    items: [
      {
        url: '/pages/supplier-profile',
        name: 'Supplier Profile',
        slug: 'page2',
        icon: 'UsersIcon',
        permissions: 'view-supplier,edit-supplier,create-supplier',
      },
      {
        url: '/pages/supplier-manufacturing',
        name: 'Manufacturing Sites',
        slug: 'supplier-manufacturing',
        icon: 'BoxIcon',
        permissions: 'view-site,edit-site,create-site',
      },
      {
        url: '/pages/supplier-user',
        name: 'User Settings',
        slug: 'page2',
        icon: 'UsersIcon',
        permissions: 'view-user,edit-user,create-user',
      },
      {
        url: '/pages/raw-materials',
        name: 'Raw Materials',
        slug: 'raw-materials',
        icon: 'TriangleIcon',
        permissions: 'view-raw-material,edit-raw-material,create-raw-material',
      },


      // {
      //   name: 'Manage Nimble',
      //   slug: 'page2',
      //   icon: 'UsersIcon',
      //   submenu: [
      //     {
      //       url: '/pages/manage-nimble/users',
      //       name: 'Staff',
      //       slug: 'page2',
      //       icon: 'UsersIcon'
      //     },
      //     {
      //       name: 'Customers',
      //       slug: 'page2',
      //       icon: 'UsersIcon'
      //     },
      //     {
      //       name: 'Suppliers',
      //       slug: 'page2',
      //       icon: 'UsersIcon'
      //     }
      //   ]
      // }
    ]
  },
  {
    header: 'Trading summary',
    icon: 'ArchiveIcon',
    items: [
      {
        url: '/pages/trading-summary/rm-orders',
        name: 'RM Orders',
        slug: 'rm-orders',
        icon: 'CircleIcon',
        permissions: 'view-order,edit-order',
      },
    ]
  }
  // {
  //   url: '/pages/patients',
  //   name: 'Patients',
  //   slug: 'page2',
  //   icon: 'UsersIcon'
  // },
  // {
  //   header: 'Settings',
  //   icon: 'UsersIcon',
  //   items: [
  //     {
  //       url: '/pages/users',
  //       name: 'Users',
  //       slug: 'page2',
  //       icon: 'UsersIcon'
  //       // submenu: [
  //       //   {
  //       //     url: '/pages/users',
  //       //     name: 'Prescribes',
  //       //     slug: 'page2',
  //       //     icon: 'FileIcon',
  //       //   },
  //       //   {
  //       //     url: '/pages/pending',
  //       //     name: 'Pending Prescribes',
  //       //     slug: 'page2',
  //       //     icon: 'FileIcon',
  //       //   }
  //       // ]
  //     },
  //     {
  //       url: '/pages/clinics',
  //       name: 'Clinics',
  //       slug: 'page2',
  //       icon: 'HomeIcon'
  //     }
  //   ]
  // }

]
